import { AlignmentType, ImageRun, Paragraph, TextRun, WidthType } from "docx";
import owasp from '../../../../../../Assests/ReportImages/OwaspTop10.png'

const owaspimg = await fetch(owasp).then(response => response.blob())

const owaspImg = new ImageRun({
    type: 'png',
    data: await owaspimg.arrayBuffer(),
    transformation: {
        width: 650,
        height: 450
    }
})

export const owaspheading = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 350 },

    children: [
        new TextRun({
            text: "OWASP:",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})


export const owaspText = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 180, after: 250, line: 270 },


    children: [
        new TextRun({
            text: "The Open Worldwide Application Security Project (OWASP) Mobile is an online community that produces freely available articles, methodologies, documentation, tools, and technologies in the fields of mobile application security.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})

export const referenceText = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 650, after: 250, },
    children: [
        new TextRun({
            text: "Reference: https://owasp.org/www-project-mobile-top-10/",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})

export const owaspTop10heading = new Paragraph({
    alignment: AlignmentType.LEFT,

    spacing: { before: 300, after: 350, },
    children: [
        new TextRun({
            text: "OWASP Top 10 – 2024",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})


export const OWASP = new Paragraph({
    alignment: AlignmentType.CENTER,
    children: [owaspImg]
})





